// extracted by mini-css-extract-plugin
export default {"button":"Button_button__LiKee","placeholder":"Button_placeholder__pvDOG","error":"Button_error__bVAnS","open":"Button_open__hqM5s"};